import React from 'react';
import styles from './PlanScrollFixedImages.module.scss';

const ScrollFixedImages = ({ dataImage }) => {
  return (
    <div className={styles.wrapper} data-aos="fade-up">
      {dataImage.map((item) => {
        return (
          <div key={item.id} className={styles.imageWrapper}>
            <div className={styles.item}>
              <img src={item.image.url} alt={item.text} className={styles.image} />
              <div className={styles.contentContainer}>
                <h3>{item.title}</h3>
                <div className={styles.text} dangerouslySetInnerHTML={{ __html: item.text }} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ScrollFixedImages;
